import FlagIcon from './FlagIcon';

export default FlagIcon;